import apisPAYS from '@/apis/apisPAYS'

/**
 * Lo que se hace al cerrar el widget de Wompi, igual en las tres pantallas que
 * cobran (Mis pagos, editar empresa y /empezar).
 *
 * El estado que trae el widget NO se usa para decidir: se le pide al backend
 * que lo confirme con Wompi. Antes cada pantalla miraba transaction.status y
 * nada mas, y el pago quedaba "Pendiente" en la base hasta que llegara el
 * webhook (que en local nunca llega).
 *
 * Devuelve { estado, mensaje, color } para mostrarlo en un aviso.
 */
export async function confirmarPagoWompi(resultado) {
  const transaccion = resultado && resultado.transaction

  // Se cerro el widget sin llegar a pagar
  if (!transaccion || !transaccion.id) {
    return {
      estado: null,
      mensaje: 'No se completó el pago. Puedes intentarlo de nuevo cuando quieras.',
      color: 'info'
    }
  }

  let estado = transaccion.status

  try {
    const confirmado = await apisPAYS.confirmar(transaccion.id)
    estado = confirmado.status
  } catch (e) {
    // Si falla la confirmacion, el webhook la hace despues: se informa con lo
    // que dijo el widget, pero sin prometer que ya quedo activo
    if (estado === 'APPROVED') {
      return {
        estado: 'PENDING',
        mensaje: 'Wompi aprobó tu pago. Lo estamos registrando; en unos minutos se activa tu hospedaje.',
        color: 'success'
      }
    }
  }

  if (estado === 'APPROVED') {
    return { estado, mensaje: 'Pago aprobado. Tu hospedaje ya está activo.', color: 'success' }
  }
  if (estado === 'PENDING') {
    return {
      estado,
      mensaje: 'Tu pago está en proceso. Cuando tu banco lo confirme se activa el hospedaje.',
      color: 'info'
    }
  }
  return {
    estado,
    mensaje: 'El pago no fue aprobado. Puedes intentarlo de nuevo con otro medio de pago.',
    color: 'error'
  }
}

export default confirmarPagoWompi
